<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Find all <a> tags with class "banner-button"
const bannerButtons = document.querySelectorAll('a.banner-button');

// Add the data-open-ask-an-expert attribute to each
bannerButtons.forEach(button => {
  button.setAttribute('data-open-ask-an-expert', '');
});